import { List, Map } from 'immutable';
import { createSelector } from 'reselect';
import { initialState } from '../reducers/mailbox';
import { peek, selector } from '../selectorHelpers';
import { selectPartnerConfig } from './partnerSelectors';

export const selectMailbox = (state) => state.get('mailbox', initialState);

const mailboxSelectAllMailboxes = selector(selectMailbox, peek('mailboxes'));

// Partner allowlist read from Redux state — selector is a pure function of
// state. createSelector memoizes on both inputs; the output recomputes only
// when mailboxes or partner config change.
export const mailboxSelectMailboxes = createSelector(
  [mailboxSelectAllMailboxes, selectPartnerConfig],
  (mailboxes, partner) => {
    const allowedCountries = new Set(partner.mailboxes.countries);
    return (mailboxes || List()).filter((m) =>
      allowedCountries.has(m.get('country')),
    );
  },
);

export const mailboxSelectLoading = selector(selectMailbox, peek('isLoading'));

const mailboxSelectArticles = selector(selectMailbox, peek('articles'));

// Index the KB articles List by `code` for O(1) per-card lookup in the
// Mailbox render loop. Non-parameterized (unlike homeSelectArticleByCode) so
// the single memo slot isn't thrashed by N per-card calls; recomputes only
// when the articles List reference changes.
export const mailboxSelectArticlesByCode = createSelector(
  [mailboxSelectArticles],
  (articles) =>
    (articles || List()).reduce((acc, a) => acc.set(a.get('code'), a), Map()),
);
